/**
 @ngdoc service
 @name progressBarService

 @description
 Designed to make adding a progress bar to a page relatively easy
 The progress bar's progress will following the curve of a circle where the radius is the total average time in milliseconds.
 The resulting effect is the progress bar will start off fast towards it's objective 100% but gradually slow down.
 The hope is give a subtle indication of progress and to produce a feel good effect that the goal is being achieved quickly before attention wanes.

 @example
 // Provide a page reference
 $scope.progressBar = progressBarService.init($scope);
 // Add as many bars as you require
 progressBarService.addBar('loadBulkData',response.data.averageTime);
 // Start the loading, please
 progressBarService.start('loadBulkData');

 // Place HTML below in you code and call
    <div class="progress-bar progress-bar-striped active" role="progressbar"
        aria-valuenow="{{progressBar.loadBulkData.percentage}}" aria-valuemin="0" aria-valuemax="100"
        style="width:{{progressBar.loadBulkData.percentage}}%">
        {{progressBar.loadBulkData.percentage}}%
    </div>

 //if required you may also stop it
 progressBarService.stop('loadBulkData');
 */
angular.module('app').service('progressBarService', function() {
    //private var for debugging file
    var DEBUG = false;

    var DEFAULTS = {
        REDRAW_TIME: 100,
        MAX_VALUE: 99.9,
        MAX_ELAPSED_TIME: 3600000 //60*60*1000
    };
    var scopeRef;


    this.init = function(scope){
        log('init()');
        scopeRef = scope;
        if(scopeRef.bars){
            log('Already initialised',scopeRef.bars);
        } else {
            scopeRef.bars = {};
        }
        return scopeRef.bars;
    };

    this.addBar = function(barId, averageLoadTime){
        log('addBar()',barId);
        this.stop(barId);
        var bar = scopeRef.bars[barId] = {
            id: barId,
            redrawTime: DEFAULTS.REDRAW_TIME,
            maxValue: DEFAULTS.MAX_VALUE,
            percentage: 0,
            elapsedTime: 0,
            averageLoadTime: averageLoadTime,
            conversionValue: null,
            interval: null,
            warningTimeout: null,
            dangerTimeout: null,
            bgColor: ''
        };
        bar.conversionValue = bar.maxValue / bar.averageLoadTime;
        log('addBar()',bar.percentage);
        log('addBar()',bar);
    };

    this.start = function(barId){
        log('start()',barId);
        var bar = scopeRef.bars[barId];
        stop(bar);
        log('bar['+barId+']', bar);
        if( bar.interval != null ){
            console.log('Error: progressBarService.start() already called for ',barId);
        } else if( bar.averageLoadTime == null || bar.averageLoadTime==undefined ){
            console.log('Error: progressBarService.start() requires averageLoadTime for ',barId);
        } else {
            bar.interval = setInterval(function () {
                animate(bar);
            }, bar.redrawTime);

            bar.warningTimeout = setTimeout(function () {
                bar.bgColor = 'bg-warning';
                log('warning',bar);
            }, bar.averageLoadTime);

            bar.dangerTimeout = setTimeout(function () {
                bar.bgColor = 'bg-danger';
                log('danger',bar);
            }, DEFAULTS.MAX_ELAPSED_TIME);

        }
        return bar;
    };

    this.stop = function(barId) {
        log('stop()',barId);
        stop(scopeRef.bars[barId]);
    };

    /**
     * Stops the animation
     * @param bar
     */
    var stop = function(bar) {
        if(bar) {
            log('stop()', bar);
            clearInterval(bar.interval);
        }
    };

    var animate = function(bar){
        log('animate()', bar);
        bar.elapsedTime += bar.redrawTime;
        bar.percentage = getProgressSlice(bar.elapsedTime, bar.averageLoadTime, bar.conversionValue, bar.maxValue );
        log(bar.percentage);
        if( isNaN(bar.percentage) || bar.percentage>=bar.maxValue || bar.elapsedTime>=bar.averageLoadTime || bar.elapsedTime > DEFAULTS.MAX_ELAPSED_TIME) {
            stop(bar);
        }
        scopeRef.$apply();
    };

    var getProgressSlice = function(elapsedTime, averageLoadTime, conversionValue, maxValue){
        //(x-a)² + (y-b)² = r²
        //(y-b)² = r² - (x-a)²
        //b is zero ... y² = r² - (x-a)²
        //y = √ ( r² - (x-a)² )
        //a = x co-ord of circle center
        //b = y co-ord of circle center
        //r = radius
        var percentageProgress = Math.sqrt(Math.pow(averageLoadTime, 2) - Math.pow((elapsedTime - averageLoadTime), 2)) * conversionValue;
        if(percentageProgress > maxValue){
            percentageProgress = maxValue;
        }
        percentageProgress = Math.round(percentageProgress * 10)/10;
        log('getProgressSlice()', percentageProgress);
        return percentageProgress;
    };

    var log = function(identifier,data){
        if(DEBUG) console.log(identifier,data);
    };
});